<template>
  <div class="row">
    <div
      class="time col text-white q-pl-lg q-py-xs text-weight-bolder"
      style="mix-blend-mode: difference;"
    >
      4:30
    </div>
    <div
      class="camera_speaker_frame"
    >
      <i class="speaker">Speaker</i>
      <b class="camera">Camera</b>
    </div>
    <div class="col row justify-end q-gutter-xs q-pr-lg q-py-sm">
      <q-icon
        name="signal_cellular_alt"
        class="text-white"
        style="mix-blend-mode: difference;"
        size="1em"
      />
      <q-icon
        name="wifi"
        class="text-white"
        style="mix-blend-mode: difference;"
        size="1em"
      />
      <q-icon
        name="battery_std"
        size="1em"
        class="text-white"
        style="transform: rotate(90deg); mix-blend-mode: difference;"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IphoneHeaderBar'
}
</script>

<style lang="scss" scoped>
.camera_speaker_frame {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 56%;
    height: 30px;
    background-color: #1f1f1f;
    border-radius: 0px 0px 40px 40px;
    z-index: 11111;
  }
.speaker, .camera {
    position: absolute;
    display: block;
    color: transparent;
    z-index: 11111;
}
.camera {
  left: -20%;
  top: 0px;
  transform: translate(180px, 4px);
  width: 12px;
  height: 12px;
  background-color: #101010;
  border-radius: 12px;
  box-shadow: inset 0px -3px 2px 0px rgba(256, 256, 256, 0.2);
  &:after {
    content: '';
    position: absolute;
    background-color: #2d4d76;
    width: 6px;
    height: 6px;
    top: 2px;
    left: 2px;
    top: 3px;
    left: 3px;
    display: block;
    border-radius: 4px;
    box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
  }
}
.speaker {
  top: 0px;
  left: 50%;
  transform: translate(-50%, 6px);
  height: 8px;
  width: 25%;
  background-color: #101010;
  border-radius: 8px;
  box-shadow: inset 0px -3px 3px 0px rgba(256, 256, 256, 0.2);
}
</style>
